import { connect, Dispatch } from 'react-redux';
import AskAQuestionUI, { AskAQuestionUIStateProps, AskAQuestionUIDispatchProps } from './AskAQuestionUI';
import { handleAcceptDealClicked, handleAskAQuestionLinkClicked } from '../../store/navigation/actionCreators';

const mapStateToProps = (_state, ownProps: AskAQuestionUIStateProps): AskAQuestionUIStateProps => {
    const alignment = ownProps.alignment || 'center';

    return {
        alignment,
        isCountered: ownProps.isCountered,
        isCounterOfferAccepted: ownProps.isCounterOfferAccepted,
        isMobile: ownProps.isMobile,
        staticImages: ownProps.staticImages,
        borderDirection: ownProps.borderDirection
    };
};

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const mapDispatchToProps = (dispatch: Dispatch, _props: AskAQuestionUIDispatchProps): AskAQuestionUIDispatchProps => {
    return {
        onClick: () => {
            dispatch(handleAskAQuestionLinkClicked());
        },
        onAcceptDealClick: () => {
            dispatch(handleAcceptDealClicked());
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(AskAQuestionUI);
